<template>
  <v-layout row pa-3>
    <v-fab-transition v-if="false">
      <v-btn color="pink" dark fixed bottom right fab @click="createItem">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-flex xs12>
      <v-alert :value="noData" dismissible color="error" icon="warning" outlined
        >We can't find any logs.</v-alert
      >
      <v-card>
        <v-toolbar text>
          <v-icon>date_range</v-icon>
          <v-toolbar-title
            >API logs ({{ items.length || 0 }} total)</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchQuery"
            v-on:keyup.enter="search(searchQuery)"
          ></v-text-field>
          <v-btn icon @click.stop="search(searchQuery)">
            <v-icon>search</v-icon>
          </v-btn>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          disable-pagination
          hide-default-footer
          :items="items"
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <a @click.stop="viewItem(props.item)">{{
                  props.item.method
                }}</a>
              </td>
              <td>
                <a @click.stop="viewItem(props.item)">{{ props.item.path }}</a>
              </td>
              <td>{{ props.item.user_id || "Unknown" }}</td>
              <td>
                <v-chip :color="getColor(props.item.response.result)" dark>{{
                  props.item.response.result
                }}</v-chip>
              </td>
              <td>
                <v-chip dark>{{ props.item.status }}</v-chip>
              </td>
              <td>
                <v-chip>{{ props.item.response.code }}</v-chip>
              </td>
              <td>
                <span>{{ props.item.body }}</span>
              </td>
              <td>
                {{
                  props.item.response.data.message ||
                    props.item.response.message
                }}
              </td>
              <td>{{ props.item.created | moment("YYYY-DD-MM H:mm") }}</td>
              <td>
                <v-btn icon @click.stop="viewItem(props.item)">
                  <v-icon>view</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>No data</template>
        </v-data-table>
        <v-footer class="pt-5"></v-footer>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import fb from "@/firebase";
//import { mapMutations } from "vuex";

const logs = fb.db.collection("api_logs").orderBy("created", "desc");

export default {
  components: {},
  data: () => ({
    items: [],
    newItemName: "",
    currentItem: {},
    searchQuery: "",
    noData: false,
    headers: [
      { text: "Method", value: "name", sortable: false },
      { text: "Endpoint", value: "name" },
      { text: "User", value: "user_id", sortable: false },
      { text: "Result", value: "result", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Code", value: "code", sortable: false },
      { text: "Body", value: "body", sortable: false },
      { text: "Message", value: "body, sortable: false" },
      { text: "Created", value: "created" },
      { text: "Actions", value: "name", sortable: false, align: "center" }
    ],
    total: 0
  }),
  firestore: {
    items: logs.limit(100)
  },
  methods: {
    viewItem(item) {
      console.log(item);
    },
    search(query) {
      this.noData = false;
      if (query && query.length >= 5) {
        this.$bind(
          "items",
          fb.db
            .collection("api_logs")
            .where("response.code", "==", query)
            .orderBy("created", "desc")
        );
      } else {
        this.$bind("items", logs);
      }
    },
    getColor(result) {
      return result === "error" ? "error" : "success";
    }
  }
};
</script>
